import { Component, Element, Event, EventEmitter, Listen, Prop } from '@stencil/core';

@Component({
  tag: 'mama-toggle-offcanvas-item',
})
export class MamaToggleOffcanvasItem {
  @Element() el!: HTMLElement;
  @Prop() nameOfClass = 'next';

  @Event()
  offcanvasChanged: EventEmitter;

  @Listen('click')
  toggleOffcanvasItem(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (target.classList.contains('back')) {
      if (this.el.parentElement) {
        this.el.parentElement.classList.remove('active');
      }
    } else {
      if (this.el.nextElementSibling) {
        this.el.nextElementSibling.classList.toggle('active');
      }
    }

    this.offcanvasChanged.emit();
  }
}
